import type { WSModel } from "@/types/ws.service";
import { WSCommands } from "@/data/ws";
import { useTruckStore } from "@/store/truck.store";

export class TruckHandler implements WSModel {
  private truckStore = useTruckStore();

  handleWSData(data: any) {
    if (!data.command) {
      return;
    }

    switch (data.command) {
      case WSCommands.truckReserved:
        this.handleTruckReserved(data);
        break;
    }
  }

  private handleTruckReserved(data: any) {
    this.truckStore.setTruckReservedWS(data);
  }
}
